import React from 'react'
import { ClipboardDocumentCheckIcon } from '@heroicons/react/24/solid'
import AppShell from '../../../Components/AppShell'
import PageHeader from '../../../Components/PageHeader'
import ToolCard from '../../../Components/ToolCard'

const SMToolsView = () => {
  return (
    <AppShell>
      <PageHeader
        kicker="Supplier Management"
        title="SM tools"
        subtitle="Run supplier bulk audit workflows."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Supplier Management' },
        ]}
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        <ToolCard
          title="Bulk Audit"
          description="Audit supplier records in bulk from this workspace."
          icon={ClipboardDocumentCheckIcon}
          to="/sm-tools/bulk-audit"
          badge="Active"
        />
      </div>
    </AppShell>
  )
}

export default SMToolsView
